import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { SalesActivity, SalesActivityCreate, SalesActivityFilter } from '../data/salesActivity';

export function createSalesActivityService(client: AxiosInstance) {
  return createCrudService<SalesActivity, SalesActivityCreate, SalesActivityFilter>(
    client,
    '/crm/SalesActivity',
    'id',
  );
}

export type SalesActivityService = CrudService<SalesActivity, SalesActivityCreate, SalesActivityFilter>;
